import { CatalogPage } from './catalog/Page'
import { DiscordApp } from './discord/DiscordApp'
import { inDiscord } from './discord/sdk'
import type { CatalogType } from './protocol'
import { Home } from './Home'
import { LegalPage } from './legal/LegalPage'
import { RoomPage } from './room/RoomPage'
import { usePath } from './router'

export function App() {
  const path = usePath()
  // Inside Discord the activity instance decides the room.
  if (inDiscord) return <DiscordApp />
  const room = path.match(/^\/r\/([A-Za-z0-9]+)\/?$/)
  if (room) return <RoomPage roomId={room[1]} />
  const title = path.match(/^\/catalog\/(movie|tv)\/(\d+)\/?$/)
  if (title) return <CatalogPage title={{ type: title[1] as CatalogType, id: Number(title[2]) }} />
  if (/^\/catalog\/?$/.test(path)) return <CatalogPage />
  if (/^\/terms\/?$/.test(path)) return <LegalPage doc="terms" />
  if (/^\/privacy\/?$/.test(path)) return <LegalPage doc="privacy" />
  return <Home />
}
